const transformTagNameByElementReference = (tagNameToBeTransformed, knownUntransformedTagName, knownUntransformedTagNameElementReference) => {
  const actualCurrentTag = knownUntransformedTagNameElementReference.tagName.toLowerCase();
  const [prefix, suffix] = actualCurrentTag.split(knownUntransformedTagName);
  return prefix + tagNameToBeTransformed + suffix;
};

export { transformTagNameByElementReference as t };

//# sourceMappingURL=tag-name.js.map